export const setAirportData = (inputData) => {
    return dispatch => {
        dispatch({
            type: "Set_Airport_Data",
            data: inputData
        });
    };
}
